export default __webpack_public_path__ + "static/media/23.0decb91b.jpg";